import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_CUSTOMISATION_OPTIONS_STATE } from "./constants/initial-customisation-state";

const initialState = {
  options: INITIAL_CUSTOMISATION_OPTIONS_STATE,
  editing: null,
  finishedEditing: false,
};

export const customisationSlice = createSlice({
  name: "customisation",
  initialState,
  reducers: {
    updateEditState(state, action) {
      state.editing = action.payload;
    },
    updatefinishedEditingState(state, action) {
      state.finishedEditing = action.payload;
    },
    updateSelectedOption(state, action) {
      state.options[state.editing].selected = action.payload;
    },
    updateSelectedOptionValueByKey(state, action) {
      state.options[state.editing][action.payload.valueKey] =
        action.payload.value;
    },
    updateOtherOption(state, action) {
      state.options[action.payload.optionKey].selected = action.payload.value;
    },
    updateOtherOptionValueByKey(state, action) {
      state.options[action.payload.optionKey][action.payload.valueKey] =
        action.payload.value;
    },
    resetCustomisationState: () => initialState,
  },
});

export const {
  updateEditState,
  updatefinishedEditingState,
  updateSelectedOption,
  updateSelectedOptionValueByKey,
  updateOtherOption,
  updateOtherOptionValueByKey,
  resetCustomisationState,
} = customisationSlice.actions;

export const selectAllOptions = (state) => state.customisation.options;

export const selectOptionFromKey = (state, key) =>
  state.customisation.options[key];

export const selectEditing = (state) => state.customisation.editing;

export const selectFinishedEditing = (state) =>
  state.customisation.finishedEditing;

export default customisationSlice.reducer;
